import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  forbidden: false,
};

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    updateModals: (ui, action) => {
      Object.assign(ui, action.payload);
    },

    resetUI: () => initialState,
  },
});

export const {
  updateModals,
  resetUI,
} = slice.actions;

export default slice;
